export const tokenLocalStorageKey = 'tokenLocalStorage';
